import { ScrollStrategyService } from 'src/app/shared/services/scroll-strategy';
import {
  RepositionScrollStrategy,
  ScrollStrategyOptions,
} from '@angular/cdk/overlay';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment-timezone';
import {
  VatService,
  CurrencyService,
  BankService,
  ClientService,
  QuotationService,
  AircraftService,
  ContractService,
  InvoiceService,
} from 'src/app/api/invoice/services';
import { AirportService } from 'src/app/api/passenger-manifest/services';
import { Subject, debounceTime } from 'rxjs';
import {
  BusinessType,
  VatDto,
  CurrencyDto,
  BankDto,
  ClientDto,
  QuotationResponseDto,
  LineItemResponse,
  AircraftDto,
  ContractDto,
  InvoiceDetailDto,
  UpdateInvoiceRequest,
  LineItemDto,
  LineItemType,
  InvoiceUpdateRequest,
} from 'src/app/api/invoice/models';
import { AirportDto } from 'src/app/api/passenger-manifest/models';
import { CommonViewDto } from '../../models/common-view-dto';
import {
  IListParams,
  IListBankParams,
  ExtendedLineItemDto,
} from '../../models/user.model';
import { DateFormatService } from '../../services/dateFormatter';
import { LOCAL_STORAGE_KEYS } from '../../models/constants';
import { LocalStorageService } from '../../services/local-storage.service';
import { BankSearchService } from '../../services/bankSearchFN';
import { arrivalAfterDepartureValidator } from '../../customValidators/departureArrivalValidator';
import { convertZuluToLocal } from 'src/app/utils/date-time.utils';

@Component({
  selector: 'app-confirm-invoce-edit',
  templateUrl: './confirm-invoce-edit.component.html',
  styleUrls: ['./confirm-invoce-edit.component.scss'],
})
export class ConfirmInvoceEditComponent implements OnInit {
  quotationForm: FormGroup;
  businessType = '';
  id = '';
  ViewDetails!: CommonViewDto;
  viewMode = true;
  vatParams = { page: 0, size: 300, search: '' };
  params = { page: 0, size: 300, search: '' };
  bankparams: IListBankParams = {
    page: 0,
    size: 300,
    search: '',
    bankByBusinessType: undefined,
  };
  layOverTimeOptions: string[] = [];
  flightTimeOptions: string[] = [];
  hourlyRateOptions: string[] = [];

  contractParams = { page: 0, size: 300, search: '', quotation: '' };
  public maxDate = new Date();
  airportOptions: AirportDto[] = [];
  airCraftParams = { page: 0, size: 100, search: '' };
  airportParams = { page: 0, size: 100, search: '' };
  currencyParams = { page: 0, size: 100, search: '' };
  defaultVat: VatDto = {};
  isFieldFocused = false;
  clientParams: IListParams = {
    page: 0,
    size: 100,
    search: '',
    clientByBusinessType: undefined,
  };
  private inputSubject = new Subject<string>();
  private currencyInputSubject = new Subject<string>();
  private airportInputSubject = new Subject<string>();
  private airCraftInputSubject = new Subject<string>();

  vatOptions: VatDto[] = [];
  currencyOptions: CurrencyDto[] = [];
  bankOptions: BankDto[] = [];
  clientOptions: ClientDto[] = [];
  invoiceDetails: InvoiceDetailDto = {};
  timeZoneOptions: any = [
    { name: 'L', value: 'LOCAL' },
    { name: 'Z', value: 'UTC' },
  ];
  additionalChargeDetails: LineItemResponse[] = [];

  flightLegdetails: LineItemResponse[] = [];
  quotationDownloadLoader = false;
  createLoading = false;
  contractLoading = false;
  error = '';
  successResponse = '';
  clientTypeOptions = [];
  aircraftOptions: AircraftDto[] = [];
  editMode = false;
  contractList: ContractDto[] = [];
  quotationDetailsLoader = false;
  public scrollStrategiesDt1: RepositionScrollStrategy[] = [];
  public scrollStrategiesDt2: RepositionScrollStrategy[] = [];
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private vatService: VatService,
    private toastr: ToastrService,
    private currencyService: CurrencyService,
    private bankService: BankService,
    private clientService: ClientService,
    public invoiceService: InvoiceService,
    public airCraftService: AircraftService,
    public airportService: AirportService,
    public contractService: ContractService,
    public dateFormatService: DateFormatService,
    private ScrollStrategyService: ScrollStrategyService,
    private localStorageService: LocalStorageService,
    private readonly sso: ScrollStrategyOptions,
    private location: Location,
    public bankSearchService: BankSearchService
  ) {
    this.maxDate.setMinutes(this.maxDate.getMinutes() + 1);

    this.quotationForm = this.fb.group({
      quoteDate: ['', [Validators.required]],
      serviceDate: ['', [Validators.required]],
      clientId: [null, [Validators.required]],
      currencyId: [null, [Validators.required]],
      bankId: [null, [Validators.required]],
      vatId: [null, [Validators.required]],
      flightLegs: this.fb.array([]),
      additionalCharge: this.fb.array([]),
      remarks: [''],
      totalOutOfScope: [''],
      total: [''],
      amount: [''],
    });
  }
  ngOnInit(): void {
    this.quotationForm.get('serviceDate')?.disable();

    this.layOverTimeOptions = this.getFromLocalStorage(
      LOCAL_STORAGE_KEYS.LAYOVER_TIME_ARRAY
    );
    this.flightTimeOptions = this.getFromLocalStorage(
      LOCAL_STORAGE_KEYS.FLIGHT_TIME_ARRAY
    );
    this.hourlyRateOptions = this.getFromLocalStorage(
      LOCAL_STORAGE_KEYS.HOURLY_RATE_ARRAY
    );
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      this.fetchVat(this.vatParams);

      if (id) {
        this.id = id;

        this.loadInvoiceDetails();
      }
      if (!this.editMode) {
        this.viewMode = false;
      }

      // fetch data on search
      this.inputSubject
        //  debounce time as needed
        .pipe(debounceTime(1000))
        .subscribe(searchTerm => {
          this.clientParams.search = searchTerm;
          this.fetchClients(this.clientParams);
        });

      this.currencyInputSubject
        //  debounce time as needed
        .pipe(debounceTime(1000))
        .subscribe(searchTerm => {
          this.currencyParams.search = searchTerm;
          this.fetchCurrency(this.currencyParams);
        });
      this.airportInputSubject
        //  debounce time as needed
        .pipe(debounceTime(1000))
        .subscribe(searchTerm => {
          this.airportParams.search = searchTerm;
          this.fetchAirPort(this.airportParams);
        });
      this.airCraftInputSubject
        //  debounce time as needed
        .pipe(debounceTime(1000))
        .subscribe(searchTerm => {
          this.airCraftParams.search = searchTerm;
          this.fetchAirCraft(this.airCraftParams);
        });
    });
    this.route.queryParams.subscribe(params => {
      this.businessType = params['module'];
    });
    this.getBusinessType();
    this.fetchCurrency(this.currencyParams);
    this.fetchBanks(this.bankparams);
    this.fetchClients(this.clientParams);
    this.fetchAirCraft(this.airCraftParams);
    this.fetchAirPort(this.airportParams);
    this.quotationForm.get('quoteDate')?.disable();
    this.quotationForm.get('total')?.disable();
    this.quotationForm.get('amount')?.disable();
    this.quotationForm.get('totalOutOfScope')?.disable();
    this.quotationForm?.get('clientId')?.disable();
    this.quotationForm?.get('currencyId')?.disable();
    this.quotationForm?.get('vatId')?.disable();
  }
  getBusinessType() {
    switch (this.businessType) {
      case 'SALES':
        this.bankparams.bankByBusinessType = BusinessType.Sales;
        this.clientParams.clientByBusinessType = [BusinessType.Sales];

        break;
      case 'FLIGHT':
        this.bankparams.bankByBusinessType = BusinessType.Flight;
        this.clientParams.clientByBusinessType = [BusinessType.Flight];

        break;
    }
  }
  onFocus(isFocused: boolean, name: string) {
    this.isFieldFocused = isFocused;

    switch (name) {
      case 'clientId':
        if (!isFocused) {
          this.inputSubject.next('');
        }
        break;

      case 'currencyId':
        if (!isFocused) {
          this.currencyInputSubject.next('');
        }
        break;
      case 'aircraft':
        if (!isFocused) {
          this.airCraftInputSubject.next('');
        }
        break;
      case 'fromAirport':
        if (!isFocused) {
          this.fetchAirPort({ page: 0, size: 100, search: '' });
        }
        break;
      case 'toAirport':
        if (!isFocused) {
          this.fetchAirPort({ page: 0, size: 100, search: '' });
        }
        break;

      default:
        break;
    }
  }

  loadInvoiceDetails() {
    this.quotationDetailsLoader = true;

    const params = { id: parseInt(this.id) };
    this.invoiceService.getInvoiceById(params).subscribe({
      next: response => {
        if (response?.data?.[0]) {
          this.contractParams.quotation =
            JSON.stringify(response?.data?.[0]?.id) || '';

          // this.fetchContracts(this.contractParams);
          this.invoiceDetails = response.data[0];
          // this.additionalCharge.clear();
          // this.flightLegs.clear();

          this.patchAdditionalCharge(
            this.invoiceDetails?.quotation?.lineItems || []
          );
          this.patchFlightLegs(this.invoiceDetails?.quotation?.lineItems || []);

          this.quotationForm?.patchValue({
            quoteDate: this.invoiceDetails?.quotation?.quoteDate,
            serviceDate: this.invoiceDetails?.serviceDate,
            totalOutOfScope: this.invoiceDetails?.quotation?.totalOutOfScope,
            clientId: this.invoiceDetails?.quotation?.client,
            total: this.invoiceDetails?.quotation?.total,
            remarks: this.invoiceDetails?.quotation?.remarks,
            currencyId: this.invoiceDetails?.quotation?.currency,
            bankId: this.invoiceDetails?.bank,
            vatId: this.invoiceDetails?.quotation?.vat,
          });
          this.quotationDetailsLoader = false;
        }
      },
      error: error => {
        this.quotationDetailsLoader = false;

        this.toastr.error(error?.error?.message);
      },
    });
  }
  patchAdditionalCharge(lineItems: LineItemResponse[]) {
    this.quotationDetailsLoader = true;
    const additionalChargeDetails = lineItems.filter(
      (item: LineItemResponse) => item.type === 'ADDITIONAL_CHARGE'
    );
    this.additionalChargeDetails = additionalChargeDetails;

    additionalChargeDetails.map((item: LineItemResponse) => {
      const newAdditionalCharge = this.fb.group({
        id: [item.id],
        itemDescription: [item?.itemDescription],
        amount: [
          { value: item?.unitPrice, disabled: true },
          [Validators.pattern('^[0-9]+(.[0-9]+)?$')],
        ],
        vatId: [{ value: item?.vat, disabled: true }],
      });
      this.additionalCharge.push(newAdditionalCharge);
    });
    this.quotationDetailsLoader = false;
  }

  patchFlightLegs(lineItems: LineItemResponse[]) {
    this.quotationDetailsLoader = true;

    const flightLegDetails = lineItems.filter(
      (item: LineItemResponse) => item.type === 'FLIGHT_LEG'
    );
    this.flightLegdetails = flightLegDetails;

    flightLegDetails.map((item: LineItemResponse) => {
      const newScrollStrategy1 =
        this.ScrollStrategyService.createCustomScrollStrategy();
      const newScrollStrategy2 =
        this.ScrollStrategyService.createCustomScrollStrategy();
      this.scrollStrategiesDt1.push(newScrollStrategy1);
      this.scrollStrategiesDt2.push(newScrollStrategy2);

      const flightLegs = this.fb.group(
        {
          id: [item.id],
          departureDateTime: [
            item.timeZoneDeparture == 'Z'
              ? new Date(
                  this.convertUtcFormat(
                    item?.departureDateTime || '',
                    item?.fromAirport?.timeZone || ''
                  )
                )
              : convertZuluToLocal(
                  item.departureDateTime || '',
                  item?.fromAirport?.timeZone || ''
                ),
            [Validators.required],
          ],
          arrivalDateTime: [
            item.timeZoneArrival == 'Z'
              ? new Date(
                  this.convertUtcFormat(
                    item?.arrivalDateTime || '',
                    item?.toAirport?.timeZone || ''
                  )
                )
              : convertZuluToLocal(
                  item.arrivalDateTime || '',
                  item?.toAirport?.timeZone || ''
                ),
            [Validators.required],
          ],
          timeZoneDeparture: [
            item.timeZoneArrival == 'Z'
              ? { name: 'Z', value: 'UTC' }
              : { name: 'L', value: 'LOCAL' },
          ],
          timeZoneArrival: [
            item.timeZoneArrival == 'Z'
              ? { name: 'Z', value: 'UTC' }
              : { name: 'L', value: 'LOCAL' },
          ],
          aircraft: [item?.aircraft, []],
          flightTime: [
            {
              value: item?.flightTime
                ? this.minutesToTime(item?.flightTime)
                : '',
              disabled: true,
            },
            [Validators.pattern(/^([0-9]{1,2}|9[0-9]):[0-5][0-9]$/)],
          ],
          pax: [item?.pax, [Validators.pattern('^[0-9]+(.[0-9]+)?$')]],
          fromAirport: [item?.fromAirport],
          toAirport: [item?.toAirport],
          hourlyRate: [
            { value: item?.hourlyRate, disabled: true },
            [Validators.pattern(/^\d+(\.\d+)?$/)],
          ],
          layOverTime: [
            {
              value: item?.layOverTime
                ? this.minutesToTime(item?.layOverTime)
                : '',
              disabled: true,
            },
            [Validators.pattern(/^([0-9]{1,2}|9[0-9]):[0-5][0-9]$/)],
          ],
          vatId: [{ value: item?.vat, disabled: true }],
          deadHead: [{ value: item?.deadHead, disabled: true }],
        },
        {
          validators: arrivalAfterDepartureValidator(),
        }
      );
      this.flightLegs.push(flightLegs);
      this.quotationDetailsLoader = false;
    });
  }
  onInput(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value;
    this.inputSubject.next(searchTerm);
  }
  onInputAirport(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value;
    this.airportInputSubject.next(searchTerm);
  }

  onInputAircraft(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value;
    this.airCraftInputSubject.next(searchTerm);
  }

  onInputCurrency(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value;
    this.currencyInputSubject.next(searchTerm);
  }
  customSearchFn(term: string, item: ClientDto) {
    return item;
  }
  customSearchFnAirCraft(term: string, item: AircraftDto) {
    return item;
  }
  customSearchFnAirport(term: string, item: AirportDto) {
    return item;
  }
  customSearchFnCurrency(term: string, item: CurrencyDto) {
    return item;
  }
  clearSearchCurrency() {
    this.currencyParams.search = '';
    this.fetchCurrency(this.currencyParams);
  }
  clearSearchAircraft() {
    this.airCraftParams.search = '';
    this.fetchCurrency(this.airCraftParams);
  }
  clearSearchAirport() {
    this.currencyParams.search = '';
    this.fetchAirPort(this.airportParams);
  }

  clearSearchClients() {
    this.clientParams.search = '';
    this.fetchClients(this.params);
  }

  onOptionChange(): void {
    // clear the search once option is selected
    this.vatParams.search = '';
    this.fetchVat(this.vatParams);
  }

  timeToMinutes(time: string): number {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  }

  minutesToTime(minutes: number): string {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${String(hours).padStart(2, '0')}:${String(
      remainingMinutes
    ).padStart(2, '0')}`;
  }

  timeZoneConvertionToUtc(date: string, Airportzone: string, format: string) {
    if (format === 'LOCAL') {
      const dateWithoutTZ = moment(date, 'YYYY-MM-DD HH:mm:ss').format(
        'YYYY-MM-DD HH:mm:ss'
      );
      const timeInNewZone = moment.tz(dateWithoutTZ, Airportzone);
      const timeInUtc = timeInNewZone
        .utc()
        .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');

      return timeInUtc;
    }

    return moment(date).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
  }

  convertUtcFormat(utcTime: string, timeZone: string) {
    const utcMoment = moment.utc(utcTime);
    const formattedDateTimeString = utcMoment.format('YYYY-MM-DDTHH:mm:ss');

    return formattedDateTimeString;
  }

  convertLocalToUTC(localDate: string, timeZone: string) {
    const localDateTime = moment.tz(localDate, timeZone);
    const utcDateTime = localDateTime.utc();

    return utcDateTime.format('YYYY-MM-DD HH:mm:ss');
  }

  // change zone b/w LOCAl and UTC
  onChangeDepartureZone(event: any, index: number) {
    const flightLeg = this.flightLegs?.at(index) as FormGroup;
    flightLeg.get('departureDateTime')?.patchValue(null);
    flightLeg.get('timeZoneArrival')?.patchValue(event);
  }
  onChangeArrivalZone(event: any, index: number) {
    const flightLeg = this.flightLegs?.at(index) as FormGroup;
    flightLeg.get('arrivalDateTime')?.patchValue(null);
  }
  // ------------------*

  //  Function to automatically calculate and display the
  // arrival date and time based on the selected departure date and time

  onDepartureDateTimeSelected(dateTime: Date, i: number, flightTime: string) {
    const flightTimeInMin = flightTime ? this.timeToMinutes(flightTime) : 0;
    const arrivalDateTime = moment(dateTime)
      .add(flightTimeInMin, 'minutes')
      .toDate();
    this.patchArrivalDateTime(i, arrivalDateTime);
  }

  patchArrivalDateTime(index: number, arrivalDateTime: Date) {
    if (index >= 0 && index < this.flightLegs.length) {
      // Update the arrivalDateTime form control for the specified flight leg index
      this.flightLegs.at(index).patchValue({
        arrivalDateTime: arrivalDateTime,
      });
    } else {
      console.error('Invalid index:', index);
    }
  }
  // ----------------------------------------

  getCurrentDateTime(Airportzone: string) {
    const currentTime = moment().tz(Airportzone);
    const formattedTime = currentTime.format('YYYY-MM-DD HH:mm:ss');
    return formattedTime;
  }

  // --- auto complete feature -------

  saveLastLegTimes() {
    const flightLegs = this.quotationForm?.value?.flightLegs;
    if (flightLegs && flightLegs.length > 0) {
      const lastLeg = flightLegs[flightLegs.length - 1];
      const { layOverTime, hourlyRate, flightTime } = lastLeg;

      this.saveToLocalStorage(
        LOCAL_STORAGE_KEYS.LAYOVER_TIME_ARRAY,
        layOverTime
      );
      this.saveToLocalStorage(LOCAL_STORAGE_KEYS.HOURLY_RATE_ARRAY, hourlyRate);
      this.saveToLocalStorage(LOCAL_STORAGE_KEYS.FLIGHT_TIME_ARRAY, flightTime);
    }
  }

  saveToLocalStorage(key: string, value: string) {
    const array = this.getFromLocalStorage(key) || [];
    const stringValue = String(value);

    if (!array.includes(stringValue)) {
      array.push(stringValue);
      if (array.length > 8) {
        array.shift();
      }
      this.localStorageService.setItem(key, JSON.stringify(array));
    }
  }

  getFromLocalStorage(key: string): string[] {
    const itemString = this.localStorageService.getItem(key);
    return itemString ? JSON.parse(itemString) : [];
  }

  fetchVat(params: IListParams) {
    this.vatService.getAllVat(params).subscribe({
      next: response => {
        if (response?.data) {
          this.vatOptions = response.data || [];

          const defaultVat = this.vatOptions?.find(
            (item: VatDto) => item?.percentage === 15
          );

          // set default vat 15 to additional charge and legs

          this.defaultVat = defaultVat || {};
          const currentVatIdValue = this.quotationForm?.get('vatId')?.value;
          if (!currentVatIdValue) {
            this.quotationForm?.patchValue({
              vatId: this.defaultVat,
            });
          }

          const flightLeg = this.flightLegs?.at(0) as FormGroup;
          const existingVatValue = flightLeg?.get('vatId')?.value;

          if (!existingVatValue || Object.keys(existingVatValue).length === 0) {
            flightLeg?.get('vatId')?.patchValue(this.defaultVat);
          }

          const additionalCharge = this.additionalCharge?.at(0) as FormGroup;
          const existingAdditionalChargeVat =
            additionalCharge?.get('vatId')?.value;

          if (
            !existingAdditionalChargeVat ||
            Object.keys(existingAdditionalChargeVat).length === 0
          ) {
            additionalCharge?.get('vatId')?.patchValue(this.defaultVat);
          }
        }
      },
      error: error => {
        this.toastr.error(error?.error?.message);
      },
    });
  }

  fetchBanks(params: IListBankParams) {
    this.bankService.getAllbanks(params).subscribe({
      next: response => {
        if (response?.data) {
          this.bankOptions = response.data[0]?.data || [];

          const currentBankIdValue = this.quotationForm?.get('bankId')?.value;

          if (!currentBankIdValue) {
            // this.quotationForm?.patchValue({
            //   bankId: [this.bankOptions[0], this.bankOptions[1]],
            // });
            if (this.bankOptions && this.bankOptions.length > 0) {
              const bankIds =
                this.bankOptions.length === 1
                  ? [this.bankOptions[0]]
                  : [this.bankOptions[0], this.bankOptions[1]];
              this.quotationForm?.patchValue({
                bankId: bankIds,
              });
            }
          }
        }
      },
      error: error => {
        this.toastr.error(error?.error?.message);
      },
    });
  }

  fetchClients(params: IListParams) {
    this.clientService.getAllClients(params).subscribe({
      next: response => {
        if (response?.data) {
          this.clientOptions = response.data[0]?.data || [];
        }
      },
      error: error => {
        this.toastr.error(error?.error?.message);
      },
    });
  }

  fetchCurrency(params: IListParams) {
    this.currencyService.getAllCurrencies(params).subscribe({
      next: response => {
        if (response?.data) {
          this.currencyOptions = response.data[0]?.data || [];
        }
      },
      error: error => {
        this.toastr.error(error?.error?.message);
      },
    });
  }

  fetchAirPort(params: IListParams) {
    this.airportService.getAllAirport(params).subscribe({
      next: response => {
        if (response?.data) {
          this.airportOptions = response.data[0]?.data || [];
        }
      },
      error: error => {
        this.toastr.error(error?.error?.message);
      },
    });
  }

  fetchAirCraft(params: IListParams) {
    this.airCraftService.getAllAircraft(params).subscribe({
      next: response => {
        if (response?.data) {
          this.aircraftOptions = response.data[0]?.data || [];
        }
      },
      error: error => {
        this.toastr.error(error?.error?.message);
      },
    });
  }

  // fetchContracts(contractParams: IListParams) {
  //   this.contractService.getAllContracts(contractParams).subscribe({
  //     next: response => {
  //       if (response?.data) {
  //         this.contractList = response.data[0]?.data || [];
  //       }
  //     },
  //     error: error => {
  //       this.toastr.error(error?.error?.message);
  //     },
  //   });
  // }
  get additionalCharge() {
    return this.quotationForm.get('additionalCharge') as FormArray;
  }

  get flightLegs() {
    return this.quotationForm.get('flightLegs') as FormArray;
  }
  goBack() {
    this.location.back();
  }
  onSubmit() {
    if (this.quotationForm.valid) {
      this.createLoading = true;
      const flightLegs: LineItemDto[] = this.quotationForm.value.flightLegs.map(
        (flightLeg: any) => {
          return {
            id: flightLeg.id,
            timeZoneArrival: flightLeg.timeZoneArrival.name,
            timeZoneDeparture: flightLeg.timeZoneDeparture.name,
            // arrivalDateTime: this.timeZoneConvertionToUtc(
            //   flightLeg.arrivalDateTime,
            //   flightLeg.toAirport.timeZone,
            //   leg.timeZoneArrival?.value
            // ),
            // departureDateTime: this.timeZoneConvertionToUtc(
            //   flightLeg.departureDateTime,
            //   flightLeg.fromAirport.timeZone,
            //   flightLeg.timeZoneDeparture?.value
            // ),
            departureDateTime: this.timeZoneConvertionToUtc(
              flightLeg.departureDateTime || '',
              flightLeg?.fromAirport?.timeZone || '',
              flightLeg?.timeZoneDeparture?.value || ''
            ),
            arrivalDateTime: this.timeZoneConvertionToUtc(
              flightLeg.arrivalDateTime || '',
              flightLeg?.toAirport?.timeZone || '',
              flightLeg?.timeZoneArrival?.value || ''
            ),
            aircraft: flightLeg?.aircraft?.id,
            pax: flightLeg.pax,
            fromAirport: flightLeg.fromAirport,
            toAirport: flightLeg.toAirport,
            type: LineItemType.FlightLeg,
          };
        }
      );
      const additionalCharges: LineItemDto[] =
        this.quotationForm.value.additionalCharge.map(
          (additionalCharge: LineItemResponse) => {
            return {
              id: additionalCharge.id,
              itemDescription: additionalCharge.itemDescription,
              type: LineItemType.AdditionalCharge,
            };
          }
        );
      const payload: InvoiceUpdateRequest = {
        // serviceDate: moment(this.quotationForm.value?.serviceDate).format(
        //   'YYYY-MM-DD'
        // ),
        bank: this.quotationForm?.value?.bankId?.map(
          (item: BankDto) => item.id
        ),
        quotation: {
          lineItems: [...flightLegs, ...additionalCharges],
          remarks: this.quotationForm.value.remarks,
        },
      };

      this.invoiceService
        .updateConfirmedInvoiceById({
          id: parseInt(this.id),
          body: payload,
        })
        .subscribe({
          next: response => {
            this.createLoading = false;
            const invoiceId = response?.data?.[0]?.id;
            this.successResponse =
              response?.message || 'Invoice updated successfully';
            this.successResponse && this.toastr.success(this.successResponse);
            if (
              this.businessType === 'SALES' ||
              this.businessType === 'SALES_WORK_ORDER'
            ) {
              this.router.navigate([`sales/invoice/show/${invoiceId}`], {
                queryParams: {
                  module: response?.data?.[0]?.quotation?.businessType,
                  type: response?.data?.[0]?.invoiceType,
                },
              });
            } else if (
              this.businessType === 'ACMS_SALES' ||
              this.businessType === 'ACMS_SALES_WORK_ORDER'
            ) {
              this.router.navigate(
                [`acms-sales/acms-sales-invoice/show/${invoiceId}`],
                {
                  queryParams: {
                    module: response?.data?.[0]?.quotation?.businessType,
                    type: response?.data?.[0]?.invoiceType,
                  },
                }
              );
            } else {
              this.router.navigate(
                [`medevac/flight/invoice/show/${invoiceId}`],
                {
                  queryParams: {
                    module: response?.data?.[0]?.quotation?.businessType,
                    type: response?.data?.[0]?.invoiceType,
                  },
                }
              );
            }
          },
          error: error => {
            this.createLoading = false;
            this.error = error?.error?.message;
            this.error && this.toastr.error(this.error);
          },
        });
    }
  }
}
